import styled from 'styled-components';

import BaseInput from '../BaseInput/BaseInput';

interface StyledBaseInputProps {
  $isExpanded: boolean;
  width?: string;
}

export const StyledBaseInput = styled(BaseInput)<StyledBaseInputProps>(
  ({ theme: { transition, size }, $isExpanded, width = '100%' }) => ({
    transition: transition.standard('width'),
    width: $isExpanded ? `calc(${width} + ${size.units(15)})` : width,
  }),
);
